/*
 * The "should the switcher appear at all" rule, in its own module.
 *
 * 🔴 IT LIVES HERE SO IT CAN BE TESTED. When it sat in SiteSelector.tsx the
 * test imported that component, which imports `persistor` from the reducers
 * module - and that builds a real redux store at import time. The suite
 * stopped running entirely, and because the run was piped through `tail` the
 * failure was invisible: the summary line still read "138 passed" and the
 * deploy went out on a suite that had not executed.
 */
export const shouldShowSelector = (sites: unknown): boolean =>
  Array.isArray(sites) && sites.length > 1;
